// extracted by mini-css-extract-plugin
export default {"button":"Profile_button__95HZC","menu":"Profile_menu__0pmwD"};